import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Alert, Button, Col, Container, Form, Row, Spinner, Table } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";

const dateValue = date => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
const money = value => Number(value).toLocaleString("ro-RO", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const formatDate = isoStr => {
  if (!isoStr) return "";
  const parts = isoStr.split("-");
  if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
  return isoStr;
};

export default function RaportAngajati() {
  const [start, setStart] = useState(() => new Date(new Date().getFullYear(), new Date().getMonth(), 1));
  const [end, setEnd] = useState(() => new Date());
  const [employeeId, setEmployeeId] = useState("");
  const [employees, setEmployees] = useState([]);
  const [report, setReport] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    let active = true;
    authFetch("/angajati/?include_inactive=true").then(data => { if (active) setEmployees(data); }).catch(err => { if (active) setError(err.message); });
    return () => { active = false; };
  }, []);
  const load = async event => {
    event.preventDefault(); setError(""); setReport(null);
    if (!start || !end || start > end) { setError("Alege un interval de date valid."); return; }
    setBusy(true);
    try {
      const params = new URLSearchParams({ data_start: dateValue(start), data_end: dateValue(end) });
      if (employeeId) params.set("angajat_id", employeeId);
      setReport(await authFetch(`/angajati/raport-manopera?${params}`));
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  };
  const change = setter => event => { setter(event.target.value); setReport(null); };
  return <Container className="py-4">
    <h3>Sume cuvenite angajaților</h3>
    <p>Repartizările salvate pe manoperă, grupate pe angajat și comandă. Intervalul include ambele date și se aplică datei manoperei, inclusiv pentru comenzile în lucru.</p>
    <Form onSubmit={load} className="d-print-none mb-4"><fieldset disabled={busy}><Row className="g-3 align-items-end">
      <Col md={3}><Form.Group controlId="raport-data-start"><Form.Label>De la</Form.Label><DatePicker id="raport-data-start" selected={start} onChange={date => { setStart(date); setReport(null); }} dateFormat="dd/MM/yyyy" className="form-control" /></Form.Group></Col>
      <Col md={3}><Form.Group controlId="raport-data-end"><Form.Label>Până la</Form.Label><DatePicker id="raport-data-end" selected={end} onChange={date => { setEnd(date); setReport(null); }} dateFormat="dd/MM/yyyy" className="form-control" /></Form.Group></Col>
      <Col md={4}><Form.Group controlId="raport-angajat"><Form.Label>Angajat</Form.Label><Form.Select value={employeeId} onChange={change(setEmployeeId)}>
        <option value="">Toți angajații</option>{employees.map(item => <option key={item.id} value={item.id}>{item.nume_prenume}{item.activ ? "" : " (inactiv)"}</option>)}
      </Form.Select></Form.Group></Col>
      <Col><Button type="submit">Afișează</Button></Col>
    </Row></fieldset></Form>
    {error && <Alert variant="danger">{error}</Alert>}
    {busy && <Spinner aria-label="Se încarcă raportul" />}
    {report && <>
      <div className="d-flex justify-content-between mb-3"><strong>Perioada: {report.data_start} – {report.data_end} · data manoperei</strong>
        <Button className="d-print-none" variant="outline-secondary" onClick={() => window.print()}>Tipărește</Button></div>
      {!report.items.length ? <Alert variant="info">Nu există sume repartizate în intervalul ales.</Alert> :
        <Table bordered responsive><thead><tr><th>Angajat</th><th>Comandă</th><th>Data comenzii</th><th className="text-end">Suma cuvenită (lei)</th></tr></thead>
          <tbody>{report.items.map(employee => <React.Fragment key={employee.angajat_id}>
            {employee.comenzi.map(order => <tr key={order.comanda_id}><td>{employee.angajat}</td>
              <td><a href={`/comenzi/interna/${order.comanda_id}/print`} target="_blank" rel="noreferrer">{order.numar_comanda || `#${order.comanda_id}`}</a></td>
              <td>{order.data_comanda}</td><td className="text-end">{money(order.suma)}</td></tr>)}
            <tr className="table-light fw-bold"><td colSpan={3}>Total {employee.angajat}</td><td className="text-end">{money(employee.total)}</td></tr>
          </React.Fragment>)}</tbody>
          <tfoot><tr className="table-primary fw-bold"><td colSpan={3}>Total general</td><td className="text-end">{money(report.total_general)}</td></tr></tfoot>
        </Table>}
    </>}
  </Container>;
}
